import React, { useEffect, useState, useRef, useMemo } from "react"
import { Pie } from "react-chartjs-2"

type Props = {
  data: number[]
  labels: string[]
  width?: number
  height?: number
  color?: Array<string>
  marketLength?: number
}

export const chartColor = ["#ff4d8b", "#3aa7ff", "#b4c0d0", "#F3F3F3"]

export const PieChart = (props: Props) => {
  const [isRedraw, redraw] = useState(false)
  const prevProps = useRef<Props>({
    data: [],
    labels: [],
    width: null,
    height: null,
  })

  const chartOptions = useMemo(() => {
    return {
      responsive: true,
      tooltips: {
        bodyFontSize: props.marketLength > 3 ? 9 : 11,
        bodySpacing: 1,
      },
    }
  }, [props.marketLength])

  const timeoutId = useRef(null)
  useEffect(() => {
    if (
      props.height !== prevProps.current.height ||
      props.width !== prevProps.current.width ||
      JSON.stringify(props.data) !== JSON.stringify(prevProps.current.data)
    ) {
      redraw(true)
      prevProps.current = props
      if (!!timeoutId.current) clearTimeout(timeoutId.current)
      timeoutId.current = setTimeout(() => {
        redraw(false)
      }, 1000)
    }
  }, [props.data, props.width, props.height])

  return (
    <Pie
      data={{
        labels: props.labels,
        datasets: [
          {
            data: props.data,
            backgroundColor: props.color ? props.color : chartColor,
            borderWidth: 0,
          },
        ],
      }}
      width={!!props.width ? props.width : 50}
      height={!!props.height ? props.height : 50}
      options={chartOptions}
      redraw={isRedraw}
      legend={{ display: false }}
    />
  )
}
